import { hasProperty } from '@/helpers';

function isScientificMerit(proposal) {
  return proposal.general.rapid_access_subtype === 'Scientific merit';
}

function setDangerRowIfEvaluationOverdue(proposal, evaluation) {
  let variant = '';
  if (!hasProperty(evaluation, 'states') || ['draft', 'auto copy'].includes(evaluation.states?.name)) {
    const submissionDay = new Date(proposal.states.date);
    const rapidAccessNewEvaluationsReleaseDate = new Date('2025-10-30');
    // because we don't want set red color for old proposals that hasn't had new types of evaluations yet
    if (submissionDay > rapidAccessNewEvaluationsReleaseDate) {
      const today = new Date();
      const millisecondsDiff = today.getTime() - submissionDay.getTime();
      if (millisecondsDiff > (21 * 24 * 60 * 60 * 1000)) {
        variant = 'danger';
      }
    }
  }
  return variant;
}

function setDataInReview(review) {
  const reviewCopy = { ...review };
  if (reviewCopy.acceptance_mark === undefined) {
    // eslint-disable-next-line camelcase
    reviewCopy.acceptance_mark = '';
  }
  if (reviewCopy.states.name === 'submitted') {
    reviewCopy.states.name += ` ${reviewCopy.states.date}`;
  }
  return reviewCopy;
}

export {
  isScientificMerit,
  setDangerRowIfEvaluationOverdue,
  setDataInReview,
};
